import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import WalletBox from "../partials/WalletBox";
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { addDepositCash } from "../../actions/contestActions";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { } from "react-router-dom";
import { toast, Toaster } from 'react-hot-toast';
import $ from 'jquery';
import classnames from "classnames";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import SidebarWallet from "./SidebarWallet";
import Moment from 'moment';
import * as myConstList from '../../BaseUrl';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { loadStripe } from "@stripe/stripe-js";
const configToken = {
  headers: {
    Authorization: 'Bearer ' + `${localStorage.getItem("jwtToken")}`,
  },
};
const baseUrl = myConstList.baseUrl;
const publicStripeKey = myConstList.stripePublicKey;
const toastStyles = {
  style: {
    borderRadius: '10px',
    background: '#fff',
    color: '#000',
  },
  errors:{},
}
class AddCashAmount extends Component {

  constructor(props) {
    super(props);


    this.state = {
      records: [],
      winningamount: "",
      isRedeemModal: false,
      attachment: "",
      transactionId: "",
      amount: "",
      logo: "",
      cashWalletBalance:0,
      errors:{},
      errorAttachment:"",
      errorTransactionId:"",
      errorAmount:"",
      urltemp: "",
      disabledButton:false,
      upiTab:1,
      creditDebitCardTab:0,
      urlTempParamConcel:"",
      urlTempParam:"",
    };

    this.columns = [
      {
        key: "tx_id",
        text: "Transaction Id",
        className: "upcase",
        align: "left",
        sortable: true,
      },
      {
        key: "amount",
        text: "Amount",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: record => {
          return (
            <Fragment>
              ₹ {record.amount}
            </Fragment>
          );
        }
      },
      {
        key: "status",
        text: "Status",
        className: "upcase",
        align: "left",
        sortable: true,

      },
      {
        key: "txStatus",
        text: "Regard To",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: record => {
          return (
            <Fragment>
              Deposit Request
            </Fragment>
          );
        }
      },
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: record => {
          return (
            <Fragment>
              {Moment(record.date).format('lll')}
            </Fragment>
          );
        }
      },
    ];

    this.columns2 = [
      {
        key: "tx_id",
        text: "Transaction Id",
        className: "upcase",
        align: "left",
        sortable: true,
      },
      {
        key: "contestName",
        text: "Contest Name",
        className: "upcase",
        align: "left",
        sortable: true,
      },
      {
        key: "amount",
        text: "Amount",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: record => {
          return (
            <Fragment>
              ₹ {record.amount}
            </Fragment>
          );
        }
      },
      {
        key: "transType",
        text: "Transaction Type",
        className: "upcase",
        align: "left",
        sortable: true
      },
      
      {
        key: "status",
        text: "Status",
        className: "upcase",
        align: "left",
        sortable: true,
  
      },
      {
        key: "txStatus",
        text: "Regard To",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: record => {
          return (
            <Fragment>
              Deposit Request
            </Fragment>
          );
        }
      },
      {
        key: "date",
        text: "Date",
        className: "upcase",
        align: "left",
        sortable: true,
        cell: record => {
          return (
            <Fragment>
              {Moment(record.date).format('lll')}
            </Fragment>
          );
        }
      },
    ];
    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Fund Request List",
      no_data_text: 'No user found!',
      button: {
        print: true,
        csv: true
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last"
        }
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    this.state = {
      records: []
    };


    this.getData = this.getData5.bind(this);
  }
  editRecord(record) {
    this.setState({ reject: record.reject, approve: record.approve });
  }
  componentWillReceiveProps(nextProps) {
    // console.log("nextPropsnextProps===========", nextProps);
    if (
      nextProps.contestdata !== undefined &&
      nextProps.contestdata.contest !== undefined &&
      nextProps.contestdata.contest.data !== undefined &&
      nextProps.contestdata.contest.data.message !== undefined &&
      nextProps.contestdata.contest.data.success
    ) {
      this.closeModal();
      toast.success(nextProps.contestdata.contest.data.message, toastStyles);
      this.getData5();
      var urltemp = "";
      if (
        localStorage.getItem("source") !== "" &&
        localStorage.getItem("theme") !== ""
      ) {
        urltemp =
          "?source=" +
          localStorage.getItem("source") +
          "&theme=" +
          localStorage.getItem("theme");
          // console.log("urlStamp==",urltemp);
        this.setState({ urltemp: urltemp,themeSet:localStorage.getItem("theme") });
      }
      setTimeout(() => {
        window.location.href = "/add-cash-amount"+urltemp;
      }, 1000);
    }else{
      if (
        nextProps.contestdata !== undefined &&
        nextProps.contestdata.contest !== undefined &&
        nextProps.contestdata.contest.data !== undefined &&
        nextProps.contestdata.contest.data.message !== undefined &&
        !nextProps.contestdata.contest.data.success
      ){
      this.closeModal();
      this.getData5();
      toast.error(nextProps.contestdata.contest.data.message, toastStyles);
      var urltemp = "";
      if (
        localStorage.getItem("source") !== "" &&
        localStorage.getItem("theme") !== ""
      ) {
        urltemp =
          "?source=" +
          localStorage.getItem("source") +
          "&theme=" +
          localStorage.getItem("theme");
          // console.log("urlStamp==",urltemp);
        this.setState({ urltemp: urltemp,themeSet:localStorage.getItem("theme") });
      }
      setTimeout(() => {
        window.location.href = "/add-cash-amount"+urltemp;
      }, 1000);
    }
    }    
  }
  componentDidMount() {
    this.setState({upiTab:1});
    var urlTempParam = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      urlTempParam =
        "&source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
        let urlTempParamConcel =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
        // console.log("urlStamp==",urltemp);
      this.setState({ urlTempParam: urlTempParam,urlTempParamConcel:urlTempParamConcel,themeSet:localStorage.getItem("theme") });
    }
    this.getData5();    
  };
  upitabFun=()=>{
    this.setState({upiTab:1,creditDebitCardTab:0});
  }
  banktabFun=()=>{
    this.setState({upiTab:0,creditDebitCardTab:1});
  }
  getData5() {
    const { user } = this.props.auth;
    axios
        .post(baseUrl + "api/profile-data", {},configToken)
        .then(res => {
            // console.log("profile-data=======",res.data.data);
            this.setState({ cashWalletBalance: res.data.data.cashWalletBalance})
        })
        .catch()
    axios
      .post(baseUrl + "api/get-deposit-transactions", {}, configToken)
      .then(res => {
        this.setState({ records: res.data.data })
      })
      .catch();
      axios
      .post(baseUrl + "api/get-cashWallet-transactions", {}, configToken)
      .then(res => {
        // console.log("CashWalletResponse=",res.data.data);
        this.setState({ cashWalletRecords: res.data.data })
      })
      .catch();
  }
  closeModal = () => {
    this.setState({
      isModalOpen: false,
      isRedeemModal: false,
      isWithdrawalModal: false,
    });
  };

  openRedeemModal = () => {
    this.setState({ isRedeemModal: true });
  };

  onChange = (e) => {
    if (e.target.id === "transactionId") {
      this.setState({
        transactionId: e.target.value,
        errorTransactionId: "",
      });
    }
    if (e.target.id === "amount") {
      this.setState({
        amount: e.target.value,
        errorAmount: "",
      });
    }

    if (e.target.name === "attachment") {
      var attachment = e.target.files[0];
      var fileSize = e.target.files[0].size;
      // if (fileSize > 5000000) {
      //   this.setState({
      //     errorAttachment: "Maximum 5 MB Image allowed.",
      //     firstSubmitIsDisabled: true,
      //     userUploadImage: false,
      //   });
      //   return false;
      // }
      // if (!attachment.name.match(/\.(jpg|jpeg|png|gif)$/)) {
      //   this.setState({
      //     errorAttachment: "Please select valid Front image jpeg,png,gif.",
      //     firstSubmitIsDisabled: true,
      //     userUploadImage: false,
      //   });
      //   return false;
      // }
      this.setState({
        logo: attachment,
        thumnailLogo: URL.createObjectURL(e.target.files[0]),
        errorAttachment:"",
      });
    }
    this.setState({ [e.target.id]: e.target.value });
  };
  onAddCash = (e) => {
    e.preventDefault();
    this.setState({disabledButton:true});
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    if(this.state.amount ==="" || this.state.amount ===undefined){
      this.setState({
          errorAmount: "Please enter amount",
      });
      return false;
    }
    if(this.state.transactionId ==="" || this.state.transactionId ===undefined){
      this.setState({
        errorTransactionId: "Please enter TransactionId",
      });
      return false;
    }
    if(localStorage.getItem("source") !== 'mobile' && (this.state.logo ==="" || this.state.logo ===undefined)){
      this.setState({
          errorAttachment: "Please enter Attachment",
      });
      return false;
    }   
    
    // if(localStorage.getItem("source") === 'mobile'){
      // console.log("regex.test(e.target.value)", regex.test(couponCodeCheck), couponCodeCheck);
      var newData = {"transactionId":this.state.transactionId,"amount": this.state.amount,"attachment": this.state.logo};     
    //   axios
    //   .post(baseUrl + "api/add-cash-deposit-mobile", newData, configToken)
    //   .then(res => {
    //     if(res.data.success){
    //       toast.success(res.data.message, toastStyles);
    //     }else{
    //       toast.error(res.data.message, toastStyles);
    //     }
    
    //     var tempUrl = "";
    // if (
    //   localStorage.getItem("source") !== "" &&
    //   localStorage.getItem("theme") !== ""
    // ) {
    //   tempUrl =
    //     "?source=" +
    //     localStorage.getItem("source") +
    //     "&theme=" +
    //     localStorage.getItem("theme");
    //   }
    //     setTimeout(() => {
    //       window.location.href = "/addCash"+tempUrl;
    //     }, 1000);
    //     // this.setState({ cashWalletRecords: res.data.data })
    //   })
    //   .catch();
    // }else{
      // console.log("regex.test(e.target.value)", regex.test(couponCodeCheck), couponCodeCheck);
      const formData = new FormData();
      const base64FileData = btoa(this.state.logo); // Your base64-encoded file data
      const blob = new Blob([base64FileData], { type: 'application/octet-stream' });
      // console.log("blob===",blob);
      // formData.append("file", blob);
      formData.append("transactionId", this.state.transactionId);      
      formData.append("amount", this.state.amount);
      formData.append("attachment", this.state.logo);
      // console.log("transactionId===",this.state.transactionId);
      // console.log("amount===",this.state.amount);
      // console.log("logo===",this.state.logo);
      // console.log("formData===",formData);
      this.props.addDepositCash(formData, config);
    // }
  };
  pageChange(pageData) {
    // console.log("OnPageChange", pageData);
  }

  makePayment = async () => {
    if (this.state.amount === "" || this.state.amount === undefined) {
      this.setState({
        errorAmount: "Please enter amount",
      });
      return false;
    }
    this.setState({ loadingProcess: true });
    const stripe = await loadStripe(publicStripeKey);
    // var urltemp = "";
    // if (typeof this.state.urltemp != 'undefined') {
    //   urltemp = this.state.urltemp;
    // }
    var url = window.location.href;
    // Extract the segments of the URL
    var segments = url.split('/');
    // console.log("window.location.href==",segments[0]+"//"+segments[2] + "/add-cash-amount/success?session_id={CHECKOUT_SESSION_ID}" + this.state.urlTempParam);
    // return false;
    let tempUrl = "";
    if(typeof this.state.urlTempParam !='undefined'){
      tempUrl = this.state.urlTempParam;
    }
    let tempConcelUrl = "";
    if(typeof this.state.urlTempParamConcel !='undefined'){
      tempConcelUrl = this.state.urlTempParamConcel;
    }
    const body = { amount: this.state.amount, success_url: segments[0]+"//"+segments[2] + "/add-cash-amount/success?session_id={CHECKOUT_SESSION_ID}" + tempUrl, cancel_url: segments[0]+"//"+segments[2] + "/add-cash-amount/cancel" + tempConcelUrl};
    // console.log("body========", body, window.location.pathname);
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(
      baseUrl + "api/create-checkout-session",
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body),
      }
    );

    const session = await response.json();
      console.log("responsePaymentData===",session);
    const result = stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      console.log(result.error);
    }
  };
  render() {
    const { errors1 } = this.state;
    return (
      <>
        <Navbar urlPath={true} symbol={false} />
        <Sidebar />
        <div className="container container2">
          <div className=" padding_d in_page">
                <div className="wallet_box text-center" >
				<div className="d-inline-flex">
				  <div className="form-check check_box">
					<label className="form-check-label">
					  <input type="radio" id="Deposit-Balance" name="select-Balance" checked={this.state.upiTab==1?"checked":""} onClick={this.upitabFun}/> <br />
					 UPI					  
					</label>
				  </div>
				  <div className="form-check check_box">
					<label className="form-check-label">
					  <input type="radio" id="Winning Balance " name="select-Balance" onClick={this.banktabFun}/> <br />
					 Credit/Debit Card
					</label>
				  </div>
				</div>
        <hr/>
        {this.state.upiTab==1 &&		
			   <div className="acan_qr">
                <p className="text-status text-danger"><b>Scan QR code or copy UPI for the payment</b></p>
                  <img src="img/barcodecw.png" alt="barcode" className="barcode_img" />
                  <p className="m-0 space-top"><b>or</b></p>
                  <p className="m-0"><b>threepointzeroverselimited@icici</b><CopyToClipboard text="threepointzeroverselimited@icici" onCopy={() => { toast.success("UPI ID Copied", toastStyles);}} >
									<i class="fa fa-clone" aria-hidden="true"></i></CopyToClipboard></p>
                  <button className="btn btn_man mt-2 pl-5 pr-5" onClick={this.openRedeemModal}> Next</button>
                </div> 
        }	
  {this.state.creditDebitCardTab==1 && <div className="acan_qr">
				<div className="row">
				<div className="col-md-6 m-auto">
        <input
                  type="number"
                  className="form-control"
                  id="amount"
                  onChange={this.onChange}
                  value={this.state.amount}
                  placeholder="Amount"
                />
                <span className="text-danger">{this.state.errorAmount}</span>
                <button className="btn btn_man pl-5 pr-5 mt-4 p-2" onClick={this.makePayment}>Deposit Now 
                </button>
                </div>
                </div>
                </div>}				
                </div>
          </div>
          {/* Withdrawal Modal Start */}
          <Modal show={this.state.isRedeemModal} onHide={this.closeModal}>
            <Modal.Header>
              <Modal.Title>Add Funds To Enter The Contest</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form noValidate onSubmit={this.onAddCash} id="add-user">
                <div>
                  <lable>Amount<span className="text-danger"> *</span></lable>
                  <input
                    type="number"
                    className="form-control"
                    id="amount"
                    onChange={this.onChange}
                    value={this.state.amount}
                  />
                  <span className="text-danger">{this.state.errorAmount}</span><br/>
                  <lable>UTR Id<span className="text-danger"> *</span></lable>
                  <input
                    type={"text"}
                    className="form-control"
                    id="transactionId"
                    onChange={this.onChange}
                    value={this.state.transactionId}
                  /> <span className="text-danger">{this.state.errorTransactionId}</span><br/>
                  {/* {localStorage.getItem("source") !== 'mobile' && <> */}
                  <lable>Attachment <span className="text-danger"> *</span></lable>
                  <input className="form-control"
                    onChange={this.onChange}
                    value={this.state.attachment}
                    id="attachment"
                    name="attachment"
                    type="file"
                  /> <span className="text-danger">Note: <br/>Please select .jpeg and .png format only.<br/>Maximum 5 MB Image allowed.</span><br/>
                  <span className="text-danger"></span><br/>                  
                  <span className="text-danger">{this.state.errorAttachment}</span><br/>
                  {/* </>} */}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={this.closeModal}
                  >
                    Close
                  </button>
                  <button
                    form="add-user"
                    type="submit"
                    className="btn btn_man"
                    onClick={this.addCash}
                    disabled={this.state.disabledButton}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
          {/* Withdrawal Modal End */}

        </div>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }

}

AddCashAmount.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  addDepositCash: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  contestdata: state.contestdata,
});

export default connect(
  mapStateToProps,
  { addDepositCash },
)(withRouter(AddCashAmount));

